/* Article navigation is an enhancement; article text and links work without JavaScript. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ms-story]:not([data-ms-toc-ready])').forEach(story => {
      story.dataset.msTocReady = 'true';
      const toc = story.querySelector('[data-ms-toc]');
      const list = story.querySelector('[data-ms-toc-links]');
      const headings = [...story.querySelectorAll('[data-ms-story-body] h2')];
      if (!toc || !list || !headings.length) return;
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `article-heading-${index + 1}`;
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        fragment.append(item);
      });
      list.replaceChildren(fragment);
      toc.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
